import { createStore } from 'vuex'
import axios from 'axios';
import { ElMessage } from 'element-plus';
import { get } from '@/network/request'
import {
    readPlayHistory,
    appendToPlayHistory,
    clearPlayHistory,
    removeFromPlayHistory,
} from '@/utils/playHistory'

export default createStore({
    state: {
        // 是否加载中
        isLoading: false,
        // 是否登录
        isLogin: false,
        // 是否外部触发打开登录框
        openLogin: false,
        // 当前用户
        user: {},
        // 分区列表
        channels: [],
        // 轮播图列表
        carousels: [],
        // 未读通知数分别对应回复、@、点赞、系统通知和动态
        msgUnread: [0, 0, 0, 0, 0],
        // 实时通讯的socket
        ws: null,
        // 用户与当前播放视频的互动数据 {love, unlove, coin, collect}
        attitudeToVideo: {},
        // 登录用户的收藏夹列表
        favorites: [],
        // 访问用户的收藏夹列表
        userFavList: [],
        // 热搜列表
        trendings: [],
        // 搜索到的相关数据数量 [视频, 用户]
        matchingCount: [0, 0],
        // 本地观看历史（与 localStorage 同步）
        playHistory: [],
    },
    mutations: {
        // 退出登录或登录过期时初始化个别数据
        initData(state) {
            state.isLogin = false;
            state.user = {};
            state.msgUnread = [0, 0, 0, 0, 0];
            state.attitudeToVideo = {};
            state.favorites = [];
        },
        // 更新登录状态
        updateIsLogin(state, isLogin) {
            state.isLogin = isLogin;
        },
        // 更新当前用户
        updateUser(state, user) {
            state.user = user;
            // console.log("更新vuex中用户信息: ", state.user);
        },
        // 更新分区列表
        updateChannels(state, channels) {
            state.channels = channels;
            // console.log("vuex中的分区: ", state.channels);
        },
        // 更新轮播图列表
        updateCarousels(state, carousels) {
            state.carousels = carousels;
            // console.log("vuex中的轮播图: ", state.carousels);
        },
        // 更新视频互动数据
        updateAttitudeToVideo(state, atv) {
            state.attitudeToVideo = atv;
            // console.log("vuex中的视频互动数据: ", state.attitudeToVideo);
        },
        updateFavorites(state, favorites) {
            state.favorites = favorites;
            // console.log("vuex中的收藏夹列表: ", state.favorites);
        },

        updateTrendings(state, trendings) {
            state.trendings = trendings;
            // console.log("vuex中的热搜列表: ", state.trendings);
        },

        updateMatchingCount(state, matchingCount) {
            state.matchingCount = matchingCount;
        },

        syncPlayHistoryFromStorage(state) {
            state.playHistory = readPlayHistory();
        },
        addToPlayHistory(state, payload) {
            state.playHistory = appendToPlayHistory(payload);
        },
        clearPlayHistoryStore(state) {
            clearPlayHistory();
            state.playHistory = [];
        },
        removePlayHistoryItem(state, videoId) {
            state.playHistory = removeFromPlayHistory(videoId);
        },

        // 处理websocket事件
        setWebSocket(state, ws) {
            state.ws = ws;
        },
        handleWsOpen() {
            // console.log("实时通信websocket已建立");
        },
        handleWsClose() {
            // 消息连接断开不代表登录失效；登录过期仍由接口认证结果处理。
            console.log("实时通信websocket已断开");
        },
        handleWsMessage(state, e) {
            const data = JSON.parse(e.data);
            // console.log(data);
            switch (data.type) {
                case "error": {
                    // 系统错误
                    if (data.data === "登录已过期") {
                        // 由于 App.vue 那先做获取用户资料在前，所以基本上这里不会出现登录过期的情况
                        state.isLogin = false;
                        state.user = {};
                        state.msgUnread = [0, 0, 0, 0, 0];
                        state.attitudeToVideo = {};
                        state.favorites = [];
                        // 清除本地token缓存
                        localStorage.removeItem("teri_token");
                    }
                    ElMessage.error(data.data);
                    break;
                }
                case "reply": {
                    // 回复我的
                    let content = data.data;
                    // console.log(content);
                    switch (content.type) {
                        case "全部已读": {
                            state.msgUnread[0] = 0; // 清除回复我的的未读数
                            break;
                        }
                        case "接收": {
                            state.msgUnread[0] ++;
                            break;
                        }
                    }
                    break;
                }
                case "at": {
                    // @ 我的
                    let content = data.data;
                    // console.log(content);
                    switch (content.type) {
                        case "全部已读": {
                            state.msgUnread[1] = 0; // 清除@我的的未读数
                            break;
                        }
                        case "接收": {
                            state.msgUnread[1] ++;
                            break;
                        }
                    }
                    break;
                }
                case "love": {
                    // 收到的赞
                    let content = data.data;
                    // console.log(content);
                    switch (content.type) {
                        case "全部已读": {
                            state.msgUnread[2] = 0; // 清除收到的赞的未读数
                            break;
                        }
                        case "接收": {
                            state.msgUnread[2] ++;
                            break;
                        }
                    }
                    break;
                }
                case "system": {
                    // 系统通知
                    let content = data.data;
                    // console.log(content);
                    switch (content.type) {
                        case "全部已读": {
                            state.msgUnread[3] = 0; // 清除系统通知的未读数
                            break;
                        }
                        case "接收": {
                            state.msgUnread[3] ++;
                            break;
                        }
                    }
                    break;
                }
                case "dynamic": {
                    // 动态
                    let content = data.content;
                    // console.log(content);
                    switch (content.type) {
                        case "全部已读": {
                            state.msgUnread[4] = 0; // 清除动态的未读数
                            break;
                        }
                        case "接收": {
                            state.msgUnread[4] ++;
                            break;
                        }
                    }
                    break;
                }
            }

        },
        handleWsError(_, e) {
            console.log("实时通信websocket报错: ", e);
        },
    },
    actions: {
        // 获取当前用户信息（若依：/productVideo/profile；原 /user/personal/info 在后端不存在会导致 Vuex 从未置为已登录）
        async getPersonalInfo(context) {
            const token = localStorage.getItem("teri_token") || localStorage.getItem("dj_token");
            if (!token) {
                return;
            }
            try {
                const result = await axios.get("/api/productVideo/profile", {
                    headers: {
                        Authorization: "Bearer " + token,
                    },
                });
                const body = result.data || {};
                if (body.code === 200 && body.data) {
                    const d = body.data;
                    context.commit("updateUser", {
                        ...d,
                        uid: d.uid != null ? d.uid : d.userId,
                        username: d.username || d.userName || "",
                        nickname: d.nickname || d.nickName || "",
                        avatar_url: d.avatar_url || d.avatar || "",
                        auth: d.auth != null ? d.auth : 0,
                    });
                    context.commit("updateIsLogin", true);
                    if (!localStorage.getItem("teri_token")) {
                        localStorage.setItem("teri_token", token);
                    }
                } else {
                    const msg = (body.msg || "").toString();
                    if (body.code === 401 || msg.indexOf("请先登录") !== -1 || msg.indexOf("登录已过期") !== -1) {
                        context.commit("initData");
                        localStorage.removeItem("teri_token");
                        localStorage.removeItem("dj_token");
                        localStorage.removeItem("dj_isLogin");
                        localStorage.removeItem("dj_user");
                    }
                }
            } catch (e) {
                const status = e.response && e.response.status;
                const code = e.response && e.response.data && e.response.data.code;
                if (status === 401 || code === 401) {
                    context.commit("initData");
                    if (context.state.ws) {
                        context.state.ws.close();
                        context.commit("setWebSocket", null);
                    }
                    localStorage.removeItem("teri_token");
                    localStorage.removeItem("dj_token");
                    localStorage.removeItem("dj_isLogin");
                    localStorage.removeItem("dj_user");
                    ElMessage.error("请登录后查看");
                }
            }
        },

        // 退出登录
        logout(context) {
            // 先修改状态再发送请求，防止token过期导致退出失败
            context.commit("initData");
            // 关闭websocket
            if (context.state.ws) {
                context.state.ws.close();
                context.commit('setWebSocket', null);
            }
            // 发送退出请求，处理redis中的缓存信息，不能用异步，不然token过期导致退出失败，后面步骤卡死
            const bearer = localStorage.getItem("teri_token") || localStorage.getItem("dj_token") || "";
            axios.get("/api/user/account/logout", {
                headers: {
                    Authorization: "Bearer " + bearer,
                },
            })
            .catch(() => {});
            // 清除本地token缓存
            localStorage.removeItem("teri_token");
            localStorage.removeItem("dj_token");
            localStorage.removeItem("dj_isLogin");
            localStorage.removeItem("dj_user");
        },

        // 获取全部未读消息数
        async getMsgUnread({ state }) {
            const res = await get("/msg-unread/all", {
                headers: { Authorization: "Bearer " + localStorage.getItem('teri_token') }
            });
            const data = res.data.data;
            state.msgUnread[0] = data.reply;
            state.msgUnread[1] = data.at;
            state.msgUnread[2] = data.love;
            state.msgUnread[3] = data.system;
            state.msgUnread[4] = data.dynamic;
        },

        // 初始化websocket实例
        connectWebSocket({ commit, state }) {
            return new Promise((resolve) => {
                if (state.ws) {
                    state.ws.close();
                    commit('setWebSocket', null); // 关闭后清空 WebSocket 实例
                }
                const wsBaseUrl = process.env.VUE_APP_WS_IM_URL;
                const ws = new WebSocket(`${wsBaseUrl}/im`);
                commit('setWebSocket', ws);

                ws.addEventListener('open', () => {
                    commit('handleWsOpen');
                    resolve(); // 解决 Promise
                });

                ws.addEventListener('close', () => commit('handleWsClose'));
                ws.addEventListener('message', e => commit('handleWsMessage', e));
                ws.addEventListener('error', e => commit('handleWsError', e));
            });
        },

        // 关闭后清空 WebSocket 实例
        async closeWebSocket({ commit, state }) {
            if (state.ws) {
                await state.ws.close();
                commit('setWebSocket', null);
            }
        },
    }
})
